
import { Options } from "vue-class-component";

import BasePage from "@/common/BasePage";

import AppUtil from "@/util/AppUtil";

import { Popup, Toast, Checkbox, Field, CellGroup } from "vant";

@Options({
  components: {
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
  },
})
/**商家核销畅享卡服务 */
export default class OrderHx extends BasePage {
  data: { serveJson: any[]; memberName: string; id: number } = {
    serveJson: [],
    memberName: "加载中...",
    id: 0,
  };
  /**全选 */
  checked = false;
  mounted() {
    if (!this.$route.query.code) {
      Toast("查无卡号，即将返回");
      setTimeout(() => {
        this.$router.replace({
          path: "/staff/search",
          query: { type: 1 },
        });
      }, 1000);
      return;
    }
    AppUtil.request(
      {
        url: "/zhShareStore/store/getMemberServeInfo",
        method: "post",
        data: { memberId: this.$route.query.code },
      },
      (res: any) => {
        console.log("核销信息", res);
        // this.order = new OrderVo(res.data);
        this.data = res.data;
      },
      "正在加载信息",
      (success: boolean) => {
        if (!success) {
          setTimeout(() => {
            this.$router.replace({
              path: "/staff/search",
              query: { type: 1 },
            });
          }, 1000);
        }
      }
    );
  }
  /**全选变化 */
  check_change() {
    //   console.log("check_change",e);
    let checked = this.checked;
    this.data.serveJson.map((val) => {
      val.checked = checked;
    });
  }
  item_change() {
    let checked = true;
    for (let i = 0; i < this.data.serveJson.length; i++) {
      if (!this.data.serveJson[i].checked) {
        checked = false;
        break;
      }
    }
    this.checked = checked;
  }
  private btn_click() {
    let arr = [];
    for (let i = 0; i < this.data.serveJson.length; i++) {
      let serve = this.data.serveJson[i];
      if (serve.checked) {
        if (!serve.num || !serve.price) {
          return Toast("请完善“" + serve.serveName + "”的服务次数和金额");
        }
        if (serve.num > serve.surplusNum) {
          return Toast("“" + serve.serveName + "”可用次数不足");
        }
        //{"serveCode":1,"serveName":ww,"currentNum":2,"serveMoney":2}
        arr.push({
          serveCode: serve.serveCode,
          serveName: serve.serveName,
          currentNum: serve.num,
          serveMoney: serve.price,
        });
      }
    }
    if (!arr.length) {
      return Toast("请选择要核销的服务");
    }
    AppUtil.request(
      {
        url: "/zhShareStore/store/confirmWriteOff",
        method: "post",
        data: { memberId: this.data.id, serveJson: JSON.stringify(arr) },
      },
      (res: any) => {
        Toast("核销成功,返回核销页面");
        setTimeout(() => {
          this.$router.replace({
            path: "/staff/search",
            query: { type: 1 },
          });
        }, 2000);
      },
      "等待后台核销..."
    );
  }
}
